const descMixin = {
  props: {
    field: {},
    fieldValue: "",
    checkFlag: false
  },
  data() {
    return {
      fieldObj: {}
    };
  },
  created() {
    this.fieldObj = new window.$sk.Desc(this.field);
  }
};
export default descMixin;
